import React from 'react';
import { BadgeProps } from '../types';

const Badge = ({ status, theme = 'light' }: BadgeProps & { theme?: 'light' | 'dark' }) => {
    const styles: Record<string, { light: string; dark: string }> = {
        Submitted: {
            light: "bg-blue-100 text-blue-700 border-blue-200",
            dark: "bg-blue-900/30 text-blue-300 border-blue-800"
        },
        Pending: {
            light: "bg-amber-100 text-amber-700 border-amber-200",
            dark: "bg-amber-900/30 text-amber-300 border-amber-800"
        },
        Reviewed: {
            light: "bg-violet-100 text-violet-700 border-violet-200",
            dark: "bg-violet-900/30 text-violet-300 border-violet-800"
        },
        Approved: {
            light: "bg-emerald-100 text-emerald-700 border-emerald-200",
            dark: "bg-emerald-900/30 text-emerald-300 border-emerald-800"
        },
        Rejected: {
            light: "bg-rose-100 text-rose-700 border-rose-200",
            dark: "bg-rose-900/30 text-rose-300 border-rose-800"
        },
        Blocked: {
            light: "bg-zinc-800 text-zinc-300 border-zinc-600",
            dark: "bg-zinc-700 text-zinc-300 border-zinc-600"
        }
    };

    const badgeStyle = styles[status] || {
        light: "bg-gray-100 text-gray-700 border-gray-200",
        dark: "bg-gray-800 text-gray-300 border-gray-700"
    };

    return (
        <span className={`px-3 py-1 rounded-full text-xs font-bold border ${theme === 'dark' ? badgeStyle.dark : badgeStyle.light} backdrop-blur-sm`}>
            {status}
        </span>
    );
};

export default Badge;